export { Link, type ILinkProps } from './link';
